import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import {
  projectAssignedAction,
  projectRejectAssignedAction,
} from "../../../../../store/slices/SalesProjectAssignSlices/projectAssignedAction";
import { useSnackbar } from "notistack";
import { fetchAllProjects } from "./../../../../../store/slices/projectsSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
  formatAmountComma,
  parseAmountNumber,
} from "../../../../../utils/decimalAmountUtils";
import { setLeadReadTrue } from "../../../../../store/slices/readSlice";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import ConsolidatedHardware from "../ResponseReceived/ConsolidatedHardware";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { fetchSalesHourlyRates } from "../../../../../store/slices/salesHourlyRateSlice";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../../store/slices/hardwareDescriptionSlice";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../../store/slices/workentriesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../../store/slices/DescriptionTask";
import QuotedExpenseTable from "../ResponseReceived/QuotedExpenseTable";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import {
  consolidateTrainingExpenseRowsForDisplay,
  filterInstallationOngoingOtherExpenseDisplayRows,
  isTrainingExpenseDisplayRow,
} from "../../../../../utils/trainingOtherExpenseSync";

const AssignShowTasks = ({
  row,
  employees,
  projectTrackingWorkEntries,
  descriptionProjectTracking,
  hardwareProjectTracking,
  setIsLoading,
  projects,
  leads,
  handlerefresh,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const currency = useCurrencySymbol();
  const { enqueueSnackbar } = useSnackbar();
  const USAComma = CommaConvert();
  const formatHours = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return "0";
    const rounded = Math.round((numericValue + Number.EPSILON) * 100) / 100;
    return rounded.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { data } = useSelector((state) => state.salesHourlyRate);
  const { mytrainings } = useSelector((state) => state.myTrainings);

  const [searchedLeadReports, setsearchedLeadReports] = useState([]);
  console.log("project11 row", row);
  console.log("project11 searchedLeadReports", searchedLeadReports);
  useEffect(() => {
    setsearchedLeadReports(row?.Projects);
  }, [row]);

  useEffect(() => {
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchAllProjects());
    dispatch(fetchQuotations());
    dispatch(fetchSalesTaxes());
    dispatch(fetchSalesHourlyRates());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const getTrainingDescriptionEntriesForProject = React.useCallback(
    (project, assigneeInput) => {
      if (!project || !assigneeInput) return [];

      const trainingsList = Array.isArray(mytrainings?.trainings)
        ? mytrainings.trainings
        : Array.isArray(mytrainings)
          ? mytrainings
          : [];

      const resolveRefId = (ref) => {
        if (ref == null || ref === "") return "";
        if (typeof ref === "object") return String(ref?._id ?? ref?.id ?? "").trim();
        return String(ref).trim();
      };

      const assigneeId = resolveRefId(assigneeInput);
      const assigneeEmail =
        typeof assigneeInput === "object"
          ? String(assigneeInput?.EmpEmail ?? assigneeInput?.email ?? "").trim().toLowerCase()
          : String(assigneeInput || "").trim().toLowerCase();
      if (!assigneeId && !assigneeEmail) return [];

      const projectId = String(project?._id || project?.ProjectID || "").trim().toLowerCase();
      const quotationId = String(project?.quotationId || project?.quotationID || project?.quotationid || "").trim();
      const projectName = String(project?.ProjectName || project?.projectname || "").trim().toLowerCase();
      const leadId = String(project?.leadid || project?.leadId || project?.LeadId || project?.LeadID || "").trim();

      const matched = trainingsList.filter((t) => {
        const assignedToRef = t?.assignedto ?? t?.assignedTo;
        const assignedToId = resolveRefId(assignedToRef);
        const assignedToEmail =
          typeof assignedToRef === "string" && assignedToRef.includes("@")
            ? assignedToRef.trim().toLowerCase()
            : "";
        const matchesAssignee =
          (assigneeId && assignedToId && assignedToId === assigneeId) ||
          (assigneeEmail && assignedToEmail && assignedToEmail === assigneeEmail);
        if (!matchesAssignee) return false;

        const tProjectId = resolveRefId(t?.projectid ?? t?.projectId ?? t?.project).toLowerCase();
        const tQuotationId = String(t?.quotationId ?? t?.quotationID ?? t?.quotationid ?? "").trim();
        const tProjectName = String(t?.projectname || "").trim().toLowerCase();
        const tLeadId = String(t?.leadid ?? t?.leadId ?? "").trim();

        return (
          (projectId && tProjectId && projectId === tProjectId) ||
          (quotationId && tQuotationId && quotationId === tQuotationId) ||
          (projectName && tProjectName && projectName === tProjectName) ||
          (leadId && tLeadId && leadId === tLeadId)
        );
      });

      const normalized = matched.map((t) => {
        const amount = Number(
          String(t?.trainingcost ?? t?.trainingCost ?? 0)
            .toString()
            .replace(/,/g, "")
        );
        const notes = t?.notes ?? t?.note ?? "";
        return {
          amount: Number.isFinite(amount) ? amount : 0,
          notes: String(notes || "").trim(),
        };
      });

      const total = normalized.reduce((sum, x) => sum + (Number(x.amount) || 0), 0);
      const joinedNotes = Array.from(new Set(normalized.map((x) => x.notes).filter(Boolean))).join("; ");
      if (total <= 0 && !joinedNotes) return [];

      return [
        {
          _id: `training_cost_${assigneeId || assigneeEmail}`,
          taskownerid: assigneeId || assigneeEmail,
          description: "Training Cost",
          value: total,
          notes: joinedNotes,
        },
      ];
    },
    [mytrainings]
  );

  const [hourlyRateData, setHourlyRateData] = useState([]);

  const getProjectInstallRates = (source) => {
    if (!source) return { perdiem: 0, avgcost: 0 };
    return {
      perdiem: Number(source.perdiem ?? 0) || 0,
      avgcost: Number(source.avgcost ?? source.averagecost ?? 0) || 0,
    };
  };

  // Match QuotedExpenseTable so main-row total equals detail total (preserve project-slice decimal rates).
  const roundAmount2 = (n) =>
    Math.round((parseAmountNumber(n) + Number.EPSILON) * 100) / 100;

  const getRoundedTaskHourlyRate = (task) => {
    if (!task) return 0;
    if (task.hourlysalary !== undefined && task.hourlysalary !== null) {
      return parseAmountNumber(task.hourlysalary);
    }
    return Math.round(
      parseAmountNumber(task.hourlysalaray) +
        parseAmountNumber(task.overheadpercentage)
    );
  };
  const [groupedProjects, setGroupedProjects] = useState([]);
  const [combinedProjects, setCombinedProjects] = useState([]);
  const [mergedProjects, setMergedProjects] = useState([]);
  console.log("project11 mergedProjects", mergedProjects);
  const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);
  console.log("project11 searchedCalcProjects", searchedCalcProjects);
  console.log("project11 groupedProjects", groupedProjects);
  console.log("project11 combinedProjects", combinedProjects);

  const [financeDataProject, setfinanceDataProject] = useState([]);
  console.log(
    "project11 searchedLeadReports financeDataProject",
    financeDataProject
  );
  useEffect(() => {
    const filteredProject = projects.filter(
      (proj) => proj.isProjecttracking === true
    );

    const qualifiedGroups = filteredProject.filter((project) => {
      // Must have at least one assigned person
      if (!project?.Assignedperson?.length) return false;

      // At least ONE assigned person must meet criteria
      return project.Assignedperson.some(
        (person) => person.salespersonstatus === "project assigned"
        // person.salespersonstatus === "project approved" || person.salespersonstatus === "project not-approved" ||
        // person.salespersonstatus === "project assigned" || person.salespersonstatus === "project not-assigned" ||
        // person.salespersonstatus === "project ongoing" ||
        // person.salespersonstatus === "project complete"
      );
    });
    setfinanceDataProject(qualifiedGroups);
  }, [projects]);

  useEffect(() => {
    if (!searchedLeadReports || !financeDataProject) return; // guard
    // Find projects that have a match in searchedLeadReports
    const matchedProjects = financeDataProject.filter((row) =>
      searchedLeadReports.some((proj) => proj.ProjectName === row.ProjectName)
    );

    setSearchedCalcProjects(matchedProjects);
  }, [searchedLeadReports, financeDataProject]);

  useEffect(() => {
    if (
      !projectTrackingWorkEntries ||
      !descriptionProjectTracking ||
      !hardwareProjectTracking
    )
      return;

    const newData = searchedCalcProjects.map((proj) => {
      const matchedEntries = projectTrackingWorkEntries.filter(
        (entry) => entry.projectid === proj._id
      );

      const matchedDescriptions = descriptionProjectTracking.filter(
        (task) => task.projectid === proj._id
      );
      const matchedHardware = hardwareProjectTracking.filter(
        (task) => task.projectid === proj._id
      );

      return {
        ProjectName: proj.ProjectName,
        ProjectID: proj._id,
        TaskList: matchedEntries,
        Description: matchedDescriptions,
        TypeService: proj.TypeService,
        HardwareList: matchedHardware,
        Assignedperson: proj.Assignedperson,
        AssignedManagerEmail: proj.AssignedManagerEmail[0],
        SalesPersonEmail: proj.SalesPersonEmail,
        managerHourlyRate: proj.managerHourlyRate,
        operationHourlyRate: proj.operationHourlyRate,
        perdiem: proj.perdiem,
        avgcost: proj.avgcost,
      };
    });

    // const grouped = Object.values(
    //   newData.reduce((acc, project) => {
    //     if (!acc[project.ProjectName]) {
    //       acc[project.ProjectName] = {
    //         ProjectName: project.ProjectName,
    //         projects: [], // hold all occurrences
    //       };
    //     }
    //     acc[project.ProjectName].projects.push(project);
    //     return acc;
    //   }, {})
    // );

    setMergedProjects(newData);
  }, [
    searchedCalcProjects,
    projectTrackingWorkEntries,
    hardwareProjectTracking,
    descriptionProjectTracking,
  ]);

  useEffect(() => {
    if (!mergedProjects || mergedProjects.length === 0) return;

    const grouped = Object.values(
      mergedProjects.reduce((acc, project) => {
        if (!acc[project.ProjectName]) {
          acc[project.ProjectName] = {
            ProjectName: project.ProjectName,
            projects: [], // Array to hold all projects with this name
          };
        }

        // Push the entire project object as-is to the projects array
        acc[project.ProjectName].projects.push({
          ProjectID: project.ProjectID,
          TypeService: project.TypeService,
          AssignedManagerEmail: project.AssignedManagerEmail,
          salespersonEmail: project.SalesPersonEmail,
          Assignedperson: project.Assignedperson || [],
          Description: project.Description || [],
          HardwareList: project.HardwareList || [],
          TaskList: project.TaskList || [],
          managerHourlyRate: project.managerHourlyRate,
          operationHourlyRate: project.operationHourlyRate,
          perdiem: project.perdiem,
          avgcost: project.avgcost,
          // Add any other fields you need
        });

        return acc;
      }, {})
    );

    setCombinedProjects(grouped);
  }, [mergedProjects]);

  useEffect(() => {
    if (!combinedProjects || !employees) return;

    const updatedProjects = combinedProjects.map((group) => {
      // Process each project in the group
      const updatedGroupProjects = group.projects.map((project) => {
        // helper to map arrays
        const enrichWithDesignation = (arr) =>
          arr.map((item) => {
            const emp = employees.find((e) => e._id === item.taskownerid);
            if (emp) {
              return {
                ...item,
                designation: `${emp.servicetype || ""} ${
                  emp.customRoles?.[0] || ""
                }`.trim(),
              };
            }
            return item;
          });

        return {
          ...project,
          Description: project.Description
            ? enrichWithDesignation(project.Description)
            : [],
          TaskList: project.TaskList
            ? enrichWithDesignation(project.TaskList)
            : [],
          HardwareList: project.HardwareList
            ? enrichWithDesignation(project.HardwareList)
            : [],
        };
      });

      return {
        ...group,
        projects: updatedGroupProjects,
      };
    });

    setGroupedProjects(updatedProjects);
  }, [combinedProjects, employees]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const employee = employees.find((emp) => emp.EmpEmail === email);

    const filtereddatat = data.filter(
      (proj) => proj.createdBy === employee?._id
    );

    setHourlyRateData(filtereddatat);
  }, [data, employees]);

  const [matchedProjects, setMatchedProjects] = useState([]);
  const [quotationProjects, setquotationProjects] = useState([]);
  console.log("project11 quotationProjects", quotationProjects);

  useEffect(() => {
    if (!groupedProjects || !hourlyRateData) return;

    const updatedProjects = groupedProjects.map((projectGroup) => {
      // Process each project within the group
      const updatedProjectsInGroup = projectGroup.projects.map((project) => {
        const assignedEmployee = employees.find(
          (emp) => emp.EmpEmail === project.salespersonEmail
        );

        console.log("assignedEmployee assignedEmployee", assignedEmployee);

        // helper to map arrays and add hourlysalary
        const enrichWithQuotation = (arr) =>
          arr.map((item) => {
            if (!item.designation) return item;

            const designationLower = String(item.designation).toLowerCase();
            const isManager =
              designationLower.includes("manager") ||
              designationLower.includes("pm");
            const isOperations =
              designationLower.includes("operations") ||
              designationLower.includes("employee");
            const managerRate = Number(project.managerHourlyRate) || 0;
            const operationRate = Number(project.operationHourlyRate) || 0;

            // Prefer locked project rates from projects slice when present.
            if (isManager && managerRate > 0) {
              return {
                ...item,
                hourlysalary: managerRate,
                overheadpercentage: 0,
              };
            }
            if (isOperations && operationRate > 0) {
              return {
                ...item,
                hourlysalary: operationRate,
                overheadpercentage: 0,
              };
            }

            const matchedQuote = hourlyRateData.find(
              (q) => q.designation === item.designation
              // &&
              //   q.createdBy === assignedEmployee?._id
            );

            if (matchedQuote) {
              return {
                ...item,
                hourlysalary:
                  (matchedQuote.hourlysalaray || 0) +
                  (matchedQuote.overheadpercentage || 0),
              };
            }
            return item;
          });

        return {
          ...project,
          TaskList: project.TaskList
            ? enrichWithQuotation(project.TaskList)
            : [],
          Description: project.Description
            ? enrichWithQuotation(project.Description)
            : [],
          HardwareList: project.HardwareList
            ? enrichWithQuotation(project.HardwareList)
            : [],
        };
      });

      return {
        ...projectGroup,
        projects: updatedProjectsInGroup,
      };
    });

    setquotationProjects(updatedProjects);
  }, [groupedProjects, hourlyRateData, employees]);

  useEffect(() => {
    if (projects?.length && row?.Projects?.length) {
      const matchedProjects = [];
      const trueProjects = row.Projects?.filter(
        (proj) => proj?.isProjecttracking
      );
      trueProjects.forEach((rowProject) => {
        // row.Projects.forEach((rowProject) => {
        const old = projects.find(
          (pro) =>
            pro?.TypeService === rowProject?.TypeService &&
            pro.ProjectName === rowProject.ProjectName
          // pro.ProjectName === rowProject.ProjectName && rowProject?.oldprojectid === pro?._id
        );

        if (old) {
          // check if both are the same project (by _id or ProjectName or both)
          const isSame =
            old._id === rowProject.oldprojectid &&
            old.ProjectName === rowProject.ProjectName &&
            old?.TypeService === rowProject?.TypeService;

          matchedProjects.push({
            _id: rowProject._id, // ✅ add row project id at top-level
            ProjectName: rowProject.ProjectName,
            TypeService: rowProject?.TypeService, // ✅ add row type service
            oldProject: old,
            newProject: isSame ? old : rowProject, // replace with old if identical
          });
        }
      });

      setMatchedProjects(matchedProjects); // <-- store in your state
    }
  }, [projects, row?.Projects]);

  const [allrowData, setAllrowData] = useState([]);

  useEffect(() => {
    if (
      matchedProjects?.length &&
      (entries?.length ||
        tasks?.length ||
        projectTrackingWorkEntries?.length ||
        descriptionProjectTracking?.length)
    ) {
      const updated = matchedProjects.map((proj) => {
        // old matches
        const oldworkEntries = entries.filter(
          (entry) => entry.projectid === proj.oldProject._id
        );
        const oldDescriptions = tasks.filter(
          (task) => task.projectid === proj.oldProject._id
        );
        const oldHardwareParts = items.filter(
          (task) => task.projectid === proj.oldProject._id
        );

        // new matches
        const newworkEntries = projectTrackingWorkEntries.filter(
          (entry) => entry.projectid === proj.newProject._id
        );
        // Include both project-tracking and non-tracking descriptions
        const newDescriptionsTracking = descriptionProjectTracking.filter(
          (desc) => desc.projectid === proj.newProject._id
        );
        const newDescriptionsFromTasks = tasks.filter(
          (desc) => desc.projectid === proj.newProject._id
        );
        const descById = new Map();
        [...newDescriptionsTracking, ...newDescriptionsFromTasks].forEach((d) => {
          if (d._id && !descById.has(d._id)) descById.set(d._id, d);
        });
        // Dedupe by (projectid, taskownerid, description) so same expense from tasks + tracking isn't counted twice (e.g. 300+300=600)
        const getDescOwnerIdForMerge = (d) =>
          d?.taskownerid && typeof d.taskownerid === "object" && d.taskownerid._id != null
            ? d.taskownerid._id
            : d?.taskownerid;
        const descByOwnerAndDesc = new Map();
        Array.from(descById.values()).forEach((d) => {
          const ownerId = String(getDescOwnerIdForMerge(d) || "");
          const descLabel = (d.description || "").trim().toLowerCase();
          const key = `${proj.newProject._id}-${ownerId}-${descLabel}`;
          if (!descByOwnerAndDesc.has(key)) descByOwnerAndDesc.set(key, d);
        });
        const newDescriptions = Array.from(descByOwnerAndDesc.values());
        const newHardwareParts = hardwareProjectTracking.filter(
          (desc) => desc.projectid === proj.newProject._id
        );

        return {
          _id: proj.newProject._id,
          TypeService: proj.newProject?.TypeService,
          ProjectName: proj.newProject.ProjectName,
          Assignedperson: proj.newProject.Assignedperson,
          oldProject: {
            _id: proj.oldProject._id,
            ProjectName: proj.oldProject.ProjectName,
            TypeService: proj.oldProject?.TypeService,
            Assignedperson: proj.oldProject.Assignedperson,
            oldworkEntries,
            oldDescriptions,
            oldHardwareParts: oldHardwareParts,
          },
          newProject: {
            proj: proj,
            _id: proj.newProject._id,
            ProjectName: proj.newProject.ProjectName,
            TypeService: proj.newProject?.TypeService,
            Assignedperson: proj.newProject.Assignedperson,
            newworkEntries,
            newDescriptions,
            newHardwareParts: newHardwareParts,
          },
        };
      });

      setAllrowData(updated); // ✅ update state
    }
  }, [
    matchedProjects,
    entries,
    tasks,
    items,
    projectTrackingWorkEntries,
    descriptionProjectTracking,
    hardwareProjectTracking,
  ]);

  const [unifitedList, setUnifitedList] = useState([]);

  useEffect(() => {
    if (allrowData?.length && employees?.length) {
      const mergedData = allrowData.map((project) => {
        const assignedData = project.newProject.Assignedperson.map((person) => {
          // 1️⃣ Find matching employee by email
          const emp = employees.find((e) => e.EmpEmail === person.email);

          if (!emp) return null; // skip if no match

          // 2️⃣ Collect role + id
          const proj = project.newProject?.proj;
          const empid = emp._id;
          const role = emp.customRoles?.[0] || null;
          const name = `${emp.EmpFirstName} ${emp.EmpLastName}`;

          // 3️⃣ Match old/new work entries and descriptions by taskownerid
          const oldworkEntries = project.oldProject.oldworkEntries.filter(
            (entry) => entry.taskownerid === empid
          );
          const newworkEntries = project.newProject?.newworkEntries.filter(
            (entry) => entry.taskownerid === empid
          );

          // Normalize taskownerid (may be raw id or populated object)
          const normalizeDescOwnerId = (d) =>
            d?.taskownerid && typeof d.taskownerid === "object" && d.taskownerid._id != null
              ? d.taskownerid._id
              : d?.taskownerid;
          const empIdStr =
            empid != null && typeof empid === "object" && "_id" in empid
              ? String(empid._id ?? "")
              : String(empid ?? "");

          const oldDescriptions = project.oldProject.oldDescriptions.filter(
            (desc) => (normalizeDescOwnerId(desc) != null ? String(normalizeDescOwnerId(desc)) : "") === empIdStr
          );
          let newDescriptions = [];

          // Other expenses: always show only this person's (manager or employee), not aggregated
          newDescriptions = (project.newProject?.newDescriptions || []).filter(
            (desc) => (normalizeDescOwnerId(desc) != null ? String(normalizeDescOwnerId(desc)) : "") === empIdStr
          );

          // Show trainings (manager/ops/any) as a locked "Training Cost" row in this person's Other Expenses.
          const trainingRows = getTrainingDescriptionEntriesForProject(
            project?.newProject,
            emp
          );
          const hasTrainingAlready = (newDescriptions || []).some(
            (d) => isTrainingExpenseDisplayRow(d)
          );
          if (!hasTrainingAlready && trainingRows?.length) {
            newDescriptions = [...newDescriptions, ...trainingRows];
          }
          newDescriptions = consolidateTrainingExpenseRowsForDisplay(newDescriptions);
          newDescriptions = filterInstallationOngoingOtherExpenseDisplayRows(
            newDescriptions,
            project.newProject
          );

          const oldHardwareParts = project.oldProject?.oldHardwareParts.filter(
            (desc) => desc.taskownerid === empid
          );
          // const newHardwareParts = project.newProject.newHardwareParts
          const uniqueByPartDescription = Object.values(
            project.newProject.newHardwareParts.reduce((acc, item) => {
              const key = item.assemblepartdescription;

              // if not present OR current quantity is higher → replace
              if (!acc[key] || item.quantity > acc[key].quantity) {
                acc[key] = item;
              }

              return acc;
            }, {})
          );
          const newHardwareParts = uniqueByPartDescription;

          // const newHardwareParts = project.newProject.newHardwareParts.filter(
          //   (desc) => desc.taskownerid === empid
          // );
          return {
            TypeService: project?.TypeService,
            name,
            empid,
            role,
            oldworkEntries,
            newworkEntries,
            oldDescriptions,
            newDescriptions,
            oldHardwareParts,
            newHardwareParts,
            proj: proj,
          };
        })
          .filter(Boolean) // remove nulls (non-matching employees)
          .sort((a, b) =>
            a?.role === "project manager"
              ? -1
              : b?.role === "project manager"
              ? 1
              : 0
          );

        // 🔹 STEP A: Hardware PM vs Operations logic
        // if (project.newProject?.TypeService === "Hardware") {

        //   // 1️⃣ Create employee map for quick lookup
        //   const empMap = assignedData.reduce((acc, e) => {
        //     acc[e.empid] = e;
        //     return acc;
        //   }, {});

        //   // 2️⃣ Collect ALL newHardwareParts
        //   const allNewHardwareParts = assignedData.flatMap(
        //     e => e.newHardwareParts || []
        //   );

        //   // 3️⃣ Group by assemblypartdescription
        //   const groupedByAssembly = allNewHardwareParts.reduce((acc, part) => {
        //     const key = part.assemblepartdescription;
        //     if (!acc[key]) acc[key] = [];
        //     acc[key].push(part);
        //     return acc;
        //   }, {});

        //   // 4️⃣ Reset processed hardware array
        //   assignedData.forEach(e => {
        //     e.hardwarePartsOngoing = [];
        //   });

        //   // 5️⃣ Find Project Manager
        //   const pmEmp = assignedData.find(
        //     e => e.role === "project manager"
        //   );

        //   // 6️⃣ Apply rules
        //   Object.entries(groupedByAssembly).forEach(([desc, parts]) => {
        //     if (!pmEmp) return;

        //     const pmParts = parts.filter(
        //       p => empMap[p.taskownerid]?.role === "project manager"
        //     );

        //     const opParts = parts.filter(
        //       p => empMap[p.taskownerid]?.role === "operations"
        //     );

        //     // ✅ Operations always keep their own parts
        //     opParts.forEach(part => {
        //       const opEmp = empMap[part.taskownerid];
        //       if (opEmp) opEmp.hardwarePartsOngoing.push(part);
        //     });

        //     // ✅ Decide PM entry
        //     if (pmParts.length && opParts.length) {

        //       const highestPM = pmParts.reduce((a, b) =>
        //         Number(b.quantity) > Number(a.quantity) ? b : a
        //       );

        //       const highestOP = opParts.reduce((a, b) =>
        //         Number(b.quantity) > Number(a.quantity) ? b : a
        //       );

        //       pmEmp.hardwarePartsOngoing.push(
        //         Number(highestOP.quantity) > Number(highestPM.quantity)
        //           ? { ...highestOP }
        //           : { ...highestPM }
        //       );

        //     } else if (!pmParts.length && opParts.length) {
        //       // 🔥 OP only → clone to PM
        //       const highestOP = opParts.reduce((a, b) =>
        //         Number(b.quantity) > Number(a.quantity) ? b : a
        //       );

        //       pmEmp.hardwarePartsOngoing.push({ ...highestOP });

        //     } else if (pmParts.length) {

        //       const highestPM = pmParts.reduce((a, b) =>
        //         Number(b.quantity) > Number(a.quantity) ? b : a
        //       );

        //       pmEmp.hardwarePartsOngoing.push({ ...highestPM });
        //     }
        //   });

        //   // 7️⃣ OPTIONAL: replace original newHardwareParts with processed data
        //   assignedData.forEach(e => {
        //     e.newHardwareParts = e.hardwarePartsOngoing;
        //   });
        // }

        const managerData = assignedData.filter(
          (emp) => emp?.role === "project manager"
        );
        const employeeData = assignedData.filter(
          (emp) => emp?.role === "operations"
        );
        return {
          ...project,
          AssignedPersonData: assignedData,
          managerData,
          employeeData,
        };
      });
      setUnifitedList(mergedData);
    }
  }, [allrowData, employees, getTrainingDescriptionEntriesForProject]);

  console.log("unifitedList assigned", unifitedList);

  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [showActionToAssign, setShowActionToAssign] = useState({});
  const dropdownRefsProbability = useRef([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const [clickedActions, setClickedActions] = useState({});

  const handleClick = (projectIndex, action) => {
    if (isViewOnly) return;
    setClickedActions((prev) => ({
      ...prev,
      [projectIndex]: action,
    }));
  };

  const handleAssignAction = async (action, proj) => {
    if (isViewOnly) return;
    const matchedLead = leads.find(
      (lead) => lead?.ProjectName === proj.ProjectName
    );

    const quotationId = matchedLead?.quotationId || proj?.quotationId;

    if (action === "accept") {
      const acceptPayload = {
        projectid: proj._id,
      };
      setIsLoading(true);
      try {
        if (quotationId) await dispatch(setLeadReadTrue(quotationId));
        await dispatch(projectAssignedAction(acceptPayload));
        enqueueSnackbar("Project Assigned Successfully", {
          variant: "success",
        });
        dispatch(fetchAllProjects());
      } catch (error) {
        console.error("Error dispatching projectAssignedAction:", error);
      } finally {
        setIsLoading(false);
        handlerefresh();
        dispatch(fetchLeads());
      }
    } else if (action === "reject") {
      const rejectPayload = {
        projectid: proj._id,
        // assignedPersonIds: matchedEmployeeIds,
        // action: "reject",
      };
      setIsLoading(true);
      try {
        await dispatch(projectRejectAssignedAction(rejectPayload));
        enqueueSnackbar("Project Rejected Successfully", {
          variant: "success",
        });
        dispatch(fetchAllProjects());
      } catch (error) {
        console.error("Failed Project Rejection", error);
      } finally {
        setIsLoading(false);
        handlerefresh();
        dispatch(fetchLeads());
      }
    }
  };

  const [clickedProj, setClickedProj] = useState({
    proj: null,
    entries: [],
    descriptionEntries: [],
    projectIndex: null,
  });

  const divRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setClickedProj({
          projectIndex: null,
          proj: null,
        }); // 👈 clear state
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickProj = (proj, projectIndex, viewType) => {
    // CRITICAL: For hardware, deduplicate parts before setting entries
    // This ensures the displayed parts match the total count (no duplicate Mini Robot entries)
    let entriesToSet = [];
    if (proj?.TypeService?.toLowerCase().includes("hardware")) {
      const allHardwareParts = proj?.newHardwareParts || [];
      // Deduplicate by assemblepartdescription, keeping the one with higher quantity
      const uniqueHardwareParts = Object.values(
        allHardwareParts.reduce((acc, item) => {
          const key = item.assemblepartdescription?.toLowerCase();
          if (!acc[key] || (item.quantity || 0) > (acc[key].quantity || 0)) {
            acc[key] = item;
          }
          return acc;
        }, {})
      );
      entriesToSet = uniqueHardwareParts;
    } else {
      entriesToSet = proj?.newworkEntries || [];
    }

    setClickedProj((prev) => ({
      proj:
        prev?.proj === proj && prev.projectIndex === projectIndex ? null : proj,
      entries: entriesToSet,
      descriptionEntries: filterInstallationOngoingOtherExpenseDisplayRows(
        proj?.newDescriptions || [],
        { TypeService: proj?.TypeService }
      ),
      projectIndex: prev.projectIndex === projectIndex ? null : projectIndex,
    }));

    if (proj && projectIndex !== null) {
      const key = `${projectIndex}-${proj.empid}`;
      setShowActionToAssign((prev) => ({
        ...prev,
        [key]: viewType,
      }));
    }
  };

  // FIXED: Helper function to get the current view type for a specific project/employee
  const getCurrentView = (projectIndex, empid) => {
    const key = `${projectIndex}-${empid}`;
    return showActionToAssign[key] || "";
  };

  // FIXED: Helper function to set view type for a specific project/employee
  const setCurrentView = (projectIndex, empid, viewType) => {
    const key = `${projectIndex}-${empid}`;
    setShowActionToAssign((prev) => ({
      ...prev,
      [key]: viewType,
    }));
  };

  const [hardwarePartsEntries, setHardwarePartsEntries] = useState(null);
  const [hardwareClickedKey, setHardwareClickedKey] = useState(null);
  const [ClickedEffort, setClickedEffort] = useState(null);

  console.log("hardwarePartsEntries hardwareClickedKey", hardwareClickedKey);

  const getAllExpenses = (project) => {
    console.log("project11 project", project);

    const matchedProjectfinal = quotationProjects
      .find((proj) => proj.ProjectName === project.ProjectName)
      ?.projects.find((p) => p.ProjectID === project._id);

    if (!matchedProjectfinal) return 0;

    console.log("project11 matchedProjectfinal", matchedProjectfinal);
    console.log("project11 quotationProjects", quotationProjects);

    const isHardwareService = project?.TypeService?.toLowerCase().includes("hardware");
    const isInstallationService = project?.TypeService?.toLowerCase().includes("installation");
    const { perdiem: projectPerdiem, avgcost: projectAvgcost } =
      getProjectInstallRates(matchedProjectfinal ?? project);
    const assignedPeople = Array.isArray(project?.Assignedperson)
      ? project.Assignedperson
      : [];

    if (!isHardwareService) {
      let totalExpensesSum = 0;

      assignedPeople.forEach((person) => {
        const emp = employees?.find((e) => e.EmpEmail === person.email);
        if (!emp) return;

        const personTasks = (matchedProjectfinal.TaskList || []).filter(
          (task) => task.taskownerid === emp._id
        );
        const taskEntry = personTasks[0];
        const hourlyRate = getRoundedTaskHourlyRate(taskEntry);
        const totalHours = personTasks.reduce(
          (sum, task) => sum + (parseFloat(task.hoursassigned) || 0),
          0
        );

        const employeeDescriptions = (matchedProjectfinal.Description || []).filter(
          (desc) => desc.taskownerid === emp._id
        );
        let otherExpenses = employeeDescriptions.reduce(
          (sum, desc) => sum + parseAmountNumber(desc.value),
          0
        );

        const firstDescription = employeeDescriptions[0];
        if (
          firstDescription &&
          ((firstDescription.typeservice &&
            firstDescription.typeservice.toLowerCase().includes("installation")) ||
            isInstallationService) &&
          firstDescription.tripduration != null
        ) {
          const tripDuration = Number(firstDescription.tripduration) || 0;
          otherExpenses +=
            tripDuration * projectPerdiem + tripDuration * projectAvgcost;
        }

        totalExpensesSum += roundAmount2(
          hourlyRate * totalHours + otherExpenses
        );
      });

      const normalizeOwnerId = (d) =>
        d?.taskownerid && typeof d.taskownerid === "object" && d.taskownerid._id != null
          ? d.taskownerid._id
          : d?.taskownerid;
      const trainingOwnerKeys = new Set(
        (matchedProjectfinal?.Description || [])
          .filter((d) => isTrainingExpenseDisplayRow(d))
          .flatMap((d) => {
            const ownerId = normalizeOwnerId(d);
            const keys = [];
            if (ownerId != null && String(ownerId).trim() !== "")
              keys.push(String(ownerId).trim().toLowerCase());
            const email = String(d?.email || "").trim().toLowerCase();
            if (email) keys.push(email);
            return keys;
          })
      );

      const trainingTotal = assignedPeople.reduce((sum, p) => {
        const emp = employees?.find((e) => e?.EmpEmail === p?.email);
        const ownerCandidates = [
          emp?._id != null ? String(emp._id).trim().toLowerCase() : "",
          String(p?.email || "").trim().toLowerCase(),
        ].filter(Boolean);
        const alreadyPresent = ownerCandidates.some((k) =>
          trainingOwnerKeys.has(k)
        );
        if (alreadyPresent) return sum;
        const rows = getTrainingDescriptionEntriesForProject(
          project,
          emp || p?.email
        );
        const totalForPerson = rows.reduce(
          (s, r) => s + parseAmountNumber(r?.value),
          0
        );
        return sum + totalForPerson;
      }, 0);

      if (trainingTotal > 0) {
        totalExpensesSum += trainingTotal;
      }

      return roundAmount2(totalExpensesSum);
    }

    const totalTaskValue = (matchedProjectfinal?.TaskList || []).reduce(
      (total, task) => {
        const hoursSpent = Number(task.hoursassigned) || 0;
        const taskValue = hoursSpent * getRoundedTaskHourlyRate(task);
        return total + taskValue;
      },
      0
    );

    let descriptionValue = 0;

    if (matchedProjectfinal?.Description?.length > 0) {
      const installationTripByOwner = {};

      matchedProjectfinal.Description.forEach((desc) => {
        const ownerId =
          desc?.taskownerid &&
          typeof desc.taskownerid === "object" &&
          desc.taskownerid._id != null
            ? desc.taskownerid._id
            : desc?.taskownerid;
        const descIsInstallation =
          desc.typeservice &&
          desc.typeservice.toLowerCase().includes("installation");
        if (
          (descIsInstallation || isInstallationService) &&
          ownerId &&
          desc.tripduration != null
        ) {
          const tripNum = Number(desc.tripduration) || 0;
          if (!installationTripByOwner[ownerId]) {
            installationTripByOwner[ownerId] = tripNum;
          } else {
            installationTripByOwner[ownerId] = Math.max(
              installationTripByOwner[ownerId],
              tripNum
            );
          }
        }

        if (desc.value) {
          descriptionValue += parseAmountNumber(desc.value);
        }
      });

      Object.values(installationTripByOwner).forEach((tripDuration) => {
        const trip = Number(tripDuration) || 0;
        descriptionValue += trip * projectPerdiem + trip * projectAvgcost;
      });
    }

    {
      const normalizeOwnerId = (d) =>
        d?.taskownerid && typeof d.taskownerid === "object" && d.taskownerid._id != null
          ? d.taskownerid._id
          : d?.taskownerid;
      const trainingOwnerKeys = new Set(
        (matchedProjectfinal?.Description || [])
          .filter((d) => isTrainingExpenseDisplayRow(d))
          .flatMap((d) => {
            const ownerId = normalizeOwnerId(d);
            const keys = [];
            if (ownerId != null && String(ownerId).trim() !== "")
              keys.push(String(ownerId).trim().toLowerCase());
            const email = String(d?.email || "").trim().toLowerCase();
            if (email) keys.push(email);
            return keys;
          })
      );

      const trainingTotal = assignedPeople.reduce((sum, p) => {
        const emp = employees?.find((e) => e?.EmpEmail === p?.email);
        const ownerCandidates = [
          emp?._id != null ? String(emp._id).trim().toLowerCase() : "",
          String(p?.email || "").trim().toLowerCase(),
        ].filter(Boolean);
        const alreadyPresent = ownerCandidates.some((k) =>
          trainingOwnerKeys.has(k)
        );
        if (alreadyPresent) return sum;
        const rows = getTrainingDescriptionEntriesForProject(
          project,
          emp || p?.email
        );
        const totalForPerson = rows.reduce(
          (s, r) => s + parseAmountNumber(r?.value),
          0
        );
        return sum + totalForPerson;
      }, 0);

      if (trainingTotal > 0) {
        descriptionValue += trainingTotal;
      }
    }
    let hardwareValue = 0;
    // if (matchedProjectfinal?.HardwareList?.length > 0) {
    //   matchedProjectfinal.HardwareList.forEach((hw) => {
    //     if (hw.totalprice) {
    //       hardwareValue += hw.totalprice;
    //     }
    //   });
    // }
    if (matchedProjectfinal?.HardwareList?.length > 0) {
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      matchedProjectfinal?.HardwareList?.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
    }
    return roundAmount2(totalTaskValue + descriptionValue + hardwareValue);
  };
  const [expenseTableData, setexpenseTableData] = useState(null);
  const [showExpensesForProject, setShowExpensesForProject] = useState(null); // Track project index that should show expenses

  console.log("expenseTableData", expenseTableData);
  console.log(
    "expenseTableData showExpensesForProject",
    showExpensesForProject
  );
  const getExpensestableData = (project) => {
    const matchedProjectfinal = quotationProjects
      .find((proj) => proj.ProjectName === project.ProjectName)
      ?.projects.find((p) => p.ProjectID === project._id);
    const base =
      matchedProjectfinal || {
        ProjectID: project?._id,
        ProjectName: project?.ProjectName,
        TypeService: project?.TypeService,
        Assignedperson: project?.Assignedperson || [],
        TaskList: [],
        Description: [],
        HardwareList: [],
      };

    // For the breakdown table, append a single "Training Cost" row per assigned person
    // (only if not already present for that taskowner).
    const assignedPeople = Array.isArray(project?.Assignedperson) ? project.Assignedperson : [];
    const trainingRows = assignedPeople.flatMap((p) => {
      const emp = employees?.find((e) => e?.EmpEmail === p?.email);
      return getTrainingDescriptionEntriesForProject(project, emp || p?.email);
    });
    const existingOwners = new Set(
      (base?.Description || [])
        .filter((d) => isTrainingExpenseDisplayRow(d))
        .map((d) => String(d?.taskownerid || ""))
    );
    const dedupedTrainingRows = trainingRows.filter((r) => !existingOwners.has(String(r?.taskownerid || "")));
    const enhanced =
      dedupedTrainingRows.length > 0
        ? { ...base, Description: [...(base?.Description || []), ...dedupedTrainingRows] }
        : base;

    setexpenseTableData(enhanced);
  };

  return (
    <>
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col w-full  group-hover:bg-gray-100"
      >
        {unifitedList?.map((project, projectIndex) => {
          const hardwareKey = `${projectIndex}-hardware-${project._id}`;
          const otherExpensesKey = `project-${projectIndex}-${project._id}`;
          const matchedQuotationProject = quotationProjects
            .find((proj) => proj.ProjectName === project.ProjectName)
            ?.projects.find((p) => p.ProjectID === project._id);
          const { perdiem: projectPerdiem, avgcost: projectAvgcost } =
            getProjectInstallRates(matchedQuotationProject ?? project);
          return (
            <div key={project._id || projectIndex} className="flex flex-col">
              <div className="flex">
                <div className=" flex ">
                  <div className="flex flex-col ">
                    {/* {project.managerData?.map((proj, index) => { */}
                    {(project.managerData?.length > 0
                      ? project.managerData
                      : [null]
                    ).map((proj, index) => {
                      const currentView = getCurrentView(
                        projectIndex,
                        proj?.empid
                      );
                      return (
                        <div key={index} className=" flex h-full">
                          <div
                            className={`w-36 border-b flex flex-col justify-center items-center break-words text-wrap text-center`}
                          >
                            {proj?.name ? (
                              <span
                                onClick={() => {
                                  handleClickProj(
                                    proj,
                                    projectIndex,
                                    currentView === "taskKey" ? "" : "taskKey"
                                  );
                                  setShowExpensesForProject(null);
                                  setHardwareClickedKey(null);
                                }}
                                className={`${
                                  clickedProj?.proj?.name === proj?.name &&
                                  clickedProj?.projectIndex === projectIndex
                                    ? "text-blue-500 "
                                    : ""
                                } flex flex-col rounded-md p-1 cursor-pointer`}
                              >
                                <span>{proj.name}</span>
                                <span>
                                  ({proj?.TypeService || ""}{" "}
                                  {proj?.role === "project manager"
                                    ? "Manager"
                                    : "Employee"}
                                  )
                                </span>
                              </span>
                            ) : null}
                          </div>
                          <div className="w-48 border-b h-full break-words text-wrap">
                            <div className=" flex h-full ">
                              <div
                                onClick={() => {
                                  handleClickProj(
                                    proj,
                                    projectIndex,
                                    "taskKey"
                                  );
                                  setShowExpensesForProject(null);
                                  setHardwareClickedKey(null);
                                }}
                                className={`w-28 h-full  flex justify-center items-center  z-[998]  cursor-pointer py-1 px-2  text-start ${
                                  currentView === "taskKey" &&
                                  clickedProj?.projectIndex === projectIndex &&
                                  clickedProj?.proj?.empid === proj?.empid
                                    ? "text-blue-500 "
                                    : ""
                                }`}
                              >
                                {proj?.TypeService?.toLowerCase().includes(
                                  "hardware"
                                )
                                  ? `${
                                      proj?.newHardwareParts?.length || 0
                                    } Parts`
                                  : `${formatHours(
                                      proj?.newworkEntries?.reduce(
                                        (sum, item) =>
                                          sum + (item.hoursassigned || 0),
                                        0
                                      )
                                    )} Hrs`}
                              </div>
                              <div
                                onClick={() => {
                                  handleClickProj(
                                    proj,
                                    projectIndex,
                                    "expenseKey"
                                  );
                                  setShowExpensesForProject(null);
                                  setHardwareClickedKey(null);
                                }}
                                className={`w-28 h-full  flex justify-center items-center z-[998] cursor-pointer py-1 px-2 text-start ${
                                  currentView === "expenseKey" &&
                                  clickedProj?.projectIndex === projectIndex &&
                                  clickedProj?.proj?.empid === proj?.empid
                                    ? "text-blue-500 "
                                    : ""
                                }`}
                              >
                                {proj?.TypeService?.toLowerCase().includes(
                                  "hardware"
                                )
                                  ? `${
                                      formatAmountComma(
                                        proj?.newDescriptions?.reduce(
                                          (sum, item) => {
                                            return sum + parseAmountNumber(item.value);
                                          },
                                          0
                                        )
                                      ) || ""
                                    }`
                                  : `
                                     ${
                                       formatAmountComma(
                                         proj?.newDescriptions?.reduce(
                                           (sum, item) => {
                                             return sum + parseAmountNumber(item.value);
                                           },
                                           0
                                         )
                                       ) || ""
                                     } 
                                `}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className=" flex flex-col ">
                    {(project.employeeData?.length > 0
                      ? project?.employeeData
                      : [null]
                    ).map((proj, index) => {
                      const currentView = getCurrentView(
                        projectIndex,
                        proj?.empid
                      );
                      return (
                        <div
                          key={index}
                          className="flex flex-col w-full h-full"
                        >
                          <div className="flex h-full">
                            <div
                              className={`w-36 border-b h-full flex flex-col justify-center items-center  p-1 break-words text-wrap text-center`}
                            >
                              {proj?.name ? (
                                <span
                                  onClick={() => {
                                    handleClickProj(
                                      proj,
                                      projectIndex,
                                      currentView === "taskKey" ? "" : "taskKey"
                                    );
                                    setShowExpensesForProject(null);
                                    setHardwareClickedKey(null);
                                  }}
                                  className={`${
                                    clickedProj?.proj?.name === proj?.name &&
                                    clickedProj?.projectIndex === projectIndex
                                      ? "text-blue-500 "
                                      : ""
                                  } flex flex-col rounded-md p-1 cursor-pointer`}
                                >
                                  {/* <span>{proj.name}</span> */}
                                  <span>
                                    {proj?.TypeService || ""}{" "}
                                    {proj?.role === "project manager"
                                      ? "Manager"
                                      : proj?.role
                                      ? project.employeeData?.length === 1
                                        ? "Employee"
                                        : `Employee ${index + 1}`
                                      : ""}
                                  </span>
                                </span>
                              ) : null}
                            </div>
                            <div className="w-52 border-b break-words text-wrap ">
                              <div className=" flex h-full">
                                <div
                                  onClick={() => {
                                    handleClickProj(
                                      proj,
                                      projectIndex,
                                      "taskKey"
                                    );
                                    setShowExpensesForProject(null);
                                    setHardwareClickedKey(null);
                                  }}
                                  className={`w-28 z-[998] cursor-pointer h-full pt-2 py-1 px-2 flex justify-center items-center  text-start ${
                                    currentView === "taskKey" &&
                                    clickedProj?.projectIndex ===
                                      projectIndex &&
                                    clickedProj?.proj?.empid === proj?.empid
                                      ? "text-blue-500 "
                                      : ""
                                  }`}
                                >
                                  {/* {proj?.TypeService?.toLowerCase().includes(
                                    "hardware"
                                  )
                                    ? `${proj?.newHardwareParts?.length || ""}   `
                                    : `
                                ${proj?.newworkEntries?.reduce((sum, item) => {
                                      return sum + (item.hoursassigned || 0);
                                    }, 0) || ""
                                    }
                                `} */}
                                  {proj?.TypeService?.toLowerCase().includes(
                                    "hardware"
                                  )
                                    ? `${
                                        proj?.newHardwareParts?.length || 0
                                      } Parts`
                                    : `${formatHours(
                                        proj?.newworkEntries?.reduce(
                                          (sum, item) =>
                                            sum + (item.hoursassigned || 0),
                                          0
                                        )
                                      )} Hrs`}
                                </div>
                                <div
                                  onClick={() => {
                                    handleClickProj(
                                      proj,
                                      projectIndex,
                                      "expenseKey"
                                    );
                                    setShowExpensesForProject(null);
                                    setHardwareClickedKey(null);
                                  }}
                                  className={`w-28  z-[998] h-full pt-2 flex justify-center items-center cursor-pointer py-1 px-2  text-start ${
                                    currentView === "expenseKey" &&
                                    clickedProj?.projectIndex ===
                                      projectIndex &&
                                    clickedProj?.proj?.empid === proj?.empid
                                      ? "text-blue-500 "
                                      : ""
                                  }`}
                                >
                                  {proj?.TypeService?.toLowerCase().includes(
                                    "hardware"
                                  )
                                    ? `${
                                        formatAmountComma(
                                          proj?.newDescriptions?.reduce(
                                            (sum, item) => {
                                              return sum + parseAmountNumber(item.value);
                                            },
                                            0
                                          )
                                        ) || ""
                                      }`
                                    : `
                                     ${
                                       formatAmountComma(
                                         proj?.newDescriptions?.reduce(
                                           (sum, item) => {
                                             return sum + parseAmountNumber(item.value);
                                           },
                                           0
                                         )
                                       ) || ""
                                     }
                                `}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="w-52  h-full flex justify-around items-center">
                    {project.AssignedPersonData[0]?.proj?.newProject?.TypeService?.toLowerCase().includes(
                      "hardware"
                    ) ? (
                      <div
                        onClick={() => {
                          getExpensestableData(
                            project.AssignedPersonData[0]?.proj?.newProject
                          );
                          // CRITICAL: Deduplicate hardware parts before setting state
                          // This ensures the table shows the same count as the total
                          const allHardwareParts =
                            project?.newProject?.newHardwareParts || [];
                          const uniqueHardwareParts = Object.values(
                            allHardwareParts.reduce((acc, item) => {
                              const key =
                                item.assemblepartdescription?.toLowerCase();
                              // Keep the one with higher quantity if duplicates exist
                              if (
                                !acc[key] ||
                                (item.quantity || 0) > (acc[key].quantity || 0)
                              ) {
                                acc[key] = item;
                              }
                              return acc;
                            }, {})
                          );
                          setHardwarePartsEntries(uniqueHardwareParts);
                          setClickedEffort(null);

                          if (hardwareClickedKey === hardwareKey) {
                            setHardwareClickedKey(null);
                          } else {
                            setHardwareClickedKey(hardwareKey);
                            setShowExpensesForProject(null);
                          }

                          setClickedProj({
                            proj: null,
                            entries: [],
                            descriptionEntries: [],
                            projectIndex: null,
                          });
                        }}
                        className={`w-[50%] h-full border-b flex justify-center items-center 
                      ${
                        hardwareClickedKey === hardwareKey
                          ? "text-blue-500"
                          : "text-black"
                      }`}
                      >
                        {project?.TypeService?.toLowerCase().includes(
                          "hardware"
                        )
                          ? `${
                              (
                                project?.newProject?.newHardwareParts || []
                              ).filter(
                                (part, i, arr) =>
                                  i ===
                                  arr.findIndex(
                                    (p) =>
                                      p.assemblepartdescription ===
                                      part.assemblepartdescription
                                  )
                              ).length
                            } Parts`
                          : `${formatHours(
                              project.newProject?.newworkEntries?.reduce(
                                (sum, item) => {
                                  return sum + (item.hoursassigned || 0);
                                },
                                0
                              )
                            )}`}
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          getExpensestableData(
                            project.AssignedPersonData[0]?.proj?.newProject
                          );
                          // CRITICAL: Deduplicate hardware parts before setting state
                          // This ensures the table shows the same count as the total
                          const allHardwareParts =
                            project?.newProject?.newHardwareParts || [];
                          const uniqueHardwareParts = Object.values(
                            allHardwareParts.reduce((acc, item) => {
                              const key =
                                item.assemblepartdescription?.toLowerCase();
                              // Keep the one with higher quantity if duplicates exist
                              if (
                                !acc[key] ||
                                (item.quantity || 0) > (acc[key].quantity || 0)
                              ) {
                                acc[key] = item;
                              }
                              return acc;
                            }, {})
                          );
                          setHardwarePartsEntries(uniqueHardwareParts);
                          if (
                            ClickedEffort === `effort-${projectIndex}` ||
                            ClickedEffort === `other-${projectIndex}`
                          ) {
                            setClickedEffort(null);
                          } else {
                            setClickedEffort(`effort-${projectIndex}`);
                          }
                          if (showExpensesForProject === otherExpensesKey) {
                            setShowExpensesForProject(null);
                          } else {
                            setShowExpensesForProject(otherExpensesKey);
                            setHardwareClickedKey(null);
                          }
                          setClickedProj({
                            proj: null,
                            entries: [],
                            descriptionEntries: [],
                            projectIndex: null,
                          });
                        }}
                        className={`w-[50%] h-full border-b flex justify-center items-center 
                      ${
                        ClickedEffort === `effort-${projectIndex}`
                          ? "text-blue-500"
                          : "text-black"
                      }`}
                      >
                        {project?.TypeService?.toLowerCase().includes(
                          "hardware"
                        )
                          ? `${
                              (
                                project?.newProject?.newHardwareParts || []
                              ).filter(
                                (part, i, arr) =>
                                  i ===
                                  arr.findIndex(
                                    (p) =>
                                      p.assemblepartdescription ===
                                      part.assemblepartdescription
                                  )
                              ).length
                            } Parts`
                          : `${formatHours(
                              project.newProject?.newworkEntries?.reduce(
                                (sum, item) => {
                                  return sum + (item.hoursassigned || 0);
                                },
                                0
                              )
                            )} Hrs`}
                      </div>
                    )}

                    <div
                      onClick={() => {
                        getExpensestableData(
                          project.AssignedPersonData[0]?.proj?.newProject
                        );
                        if (
                          ClickedEffort === `other-${projectIndex}` ||
                          ClickedEffort === `effort-${projectIndex}`
                        ) {
                          setClickedEffort(null);
                        } else {
                          setClickedEffort(`other-${projectIndex}`);
                        }
                        if (showExpensesForProject === otherExpensesKey) {
                          setShowExpensesForProject(null);
                        } else {
                          setShowExpensesForProject(otherExpensesKey);
                          setHardwareClickedKey(null);
                        }
                        setClickedProj({
                          proj: null,
                          entries: [],
                          descriptionEntries: [],
                          projectIndex: null,
                        });
                      }}
                      className={`w-[50%] h-full border-b flex justify-center items-center 
                      ${
                        ClickedEffort === `other-${projectIndex}`
                          ? "text-blue-500"
                          : "text-black"
                      } `}
                    >
                      {/* {USAComma(
                        project.newProject?.newDescriptions?.reduce(
                          (sum, item) => {
                            return sum + (item.value || 0);
                          },
                          0
                        ) || ""
                      )}  */}
                      {formatAmountComma(
                        getAllExpenses(
                          project.AssignedPersonData[0]?.proj?.newProject
                        )
                      )}
                    </div>
                  </div>
                </div>

                <div className="w-44 border-b flex justify-center items-center align-middle break-words text-wrap">
                  <div
                    ref={(el) =>
                      (dropdownRefsProbability.current[projectIndex] = el)
                    }
                    className="w-[80%] flex relative p-0 rounded-xl align-middle items-center"
                  >
                    <button
                      type="button"
                      disabled={isViewOnly}
                      onClick={() => {
                        if (isViewOnly) return;
                        setOpenProbabilityIndex(
                          openProbabilityIndex === projectIndex
                            ? null
                            : projectIndex
                        );
                        setOpenDropdownIndex(openDropdownIndex === null);
                      }}
                      className="relative border w-full text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none"
                      style={isViewOnly ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                    >
                      {project.Assignedperson?.every(
                        (person) => person.salespersonaction === "accept"
                      )
                        ? "Accepted"
                        : project.Assignedperson?.every(
                            (person) => person.salespersonaction === "reject"
                          )
                        ? "Rejected"
                        : clickedActions[projectIndex]
                        ? clickedActions[projectIndex]
                        : "Select Option"}

                      <ExpandMoreIcon
                        className={`absolute cursor-pointer top-1 right-0 bg-white border-r ${"group-hover:bg-gray-100"}`}
                        style={isViewOnly ? { cursor: "not-allowed" } : {}}
                        onClick={() => {
                          if (isViewOnly) return;
                          setOpenProbabilityIndex(
                            openProbabilityIndex === projectIndex
                              ? null
                              : projectIndex
                          );
                          setOpenDropdownIndex(openDropdownIndex === null);
                        }}
                      />
                    </button>
                    {openProbabilityIndex === projectIndex && (
                      <div
                        style={{ zIndex: 9999 }}
                        className="text-start absolute top-full left-0 w-full p-1 cursor-pointer overflow-y-auto bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1"
                      >
                        <>
                          {!project.Assignedperson?.every(
                            (person) => person.salespersonaction === "accept"
                          ) && (
                            <div
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              style={isViewOnly ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                              onClick={() => {
                                if (isViewOnly) return;
                                handleAssignAction("accept", project);
                                handleClick(projectIndex, "Accepted");
                                setOpenProbabilityIndex(
                                  openProbabilityIndex === projectIndex
                                    ? null
                                    : projectIndex
                                );
                                setClickedProj({});
                              }}
                            >
                              Accept
                            </div>
                          )}

                          {!project.Assignedperson?.every(
                            (person) => person.salespersonaction === "reject"
                          ) && (
                            <div
                              onClick={() => {
                                if (isViewOnly) return;
                                handleAssignAction("reject", project);
                                handleClick(projectIndex, "Rejected");
                                setOpenProbabilityIndex(
                                  openProbabilityIndex === projectIndex
                                    ? null
                                    : projectIndex
                                );
                                setClickedProj({});
                              }}
                              className="p-1 hover:bg-gray-200 cursor-pointer"
                              style={isViewOnly ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                            >
                              Reject
                            </div>
                          )}
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {hardwareClickedKey === hardwareKey && (
                <ConsolidatedHardware hardwareEntries={hardwarePartsEntries} />
              )}
              {showExpensesForProject === otherExpensesKey && (
                <QuotedExpenseTable
                  expenseTableData={expenseTableData}
                  employeeData={employees}
                  perdiem={projectPerdiem}
                  averagecost={projectAvgcost}
                  preserveDecimalHourlyRates
                  personOtherExpensesOverride={(() => {
                    // Use processed per-person data (managerData/employeeData) so summary matches the project list
                    if (!expenseTableData?.Assignedperson || !project?.AssignedPersonData) return undefined;
                    const isInstallation = project?.TypeService?.toLowerCase().includes("installation");
                    const perdiemNum = projectPerdiem;
                    const averagecostNum = projectAvgcost;
                    return expenseTableData.Assignedperson.map((assignedPerson) => {
                      const emp = employees?.find((e) => e.EmpEmail === assignedPerson.email);
                      const personData = project.AssignedPersonData?.find((d) => d.empid === emp?._id);
                      let otherExpenses =
                        personData?.newDescriptions?.reduce(
                          (sum, item) => sum + (Number(item.value) || 0),
                          0
                        ) ?? 0;
                      // For installation service: add per diem + average cost from trip duration (same as Response Received)
                      if (isInstallation && personData?.newDescriptions?.length) {
                        const maxTripDuration = personData.newDescriptions.reduce((max, d) => {
                          const t = Number(d.tripduration) || 0;
                          return t > max ? t : max;
                        }, 0);
                        otherExpenses += (maxTripDuration * perdiemNum) + (maxTripDuration * averagecostNum);
                      }
                      return { email: assignedPerson.email, otherExpenses };
                    });
                  })()}
                />
              )}

              {clickedProj?.projectIndex === projectIndex &&
                clickedProj?.proj && (
                  <div className="w-full ">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className={`w-full rounded-lg h-full flex pb-5 ${
                        clickedProj?.proj?.role === "project manager"
                          ? "justify-start"
                          : clickedProj?.proj?.role === "operations"
                          ? "justify-center"
                          : ""
                      }`}
                    >
                      <div className={`w-[33%] rounded-md overflow-hidden`}>
                        <div className={`p-1 flex"justify-center gap-2`}>
                          <div
                            onClick={() =>
                              setCurrentView(
                                projectIndex,
                                clickedProj.proj.empid,
                                "taskKey"
                              )
                            }
                            className={`z-[998] cursor-pointer py-1 px-2 inline-block border mr-2 rounded-md text-start ${
                              getCurrentView(
                                projectIndex,
                                clickedProj.proj.empid
                              ) === "taskKey"
                                ? "bg-blue-500 text-white"
                                : "bg-white"
                            }`}
                          >
                            {`${
                              clickedProj?.proj?.TypeService?.toLowerCase().includes(
                                "hardware"
                              )
                                ? "Part List"
                                : "Effort Expenses"
                            } `}
                          </div>
                          <div
                            onClick={() =>
                              setCurrentView(
                                projectIndex,
                                clickedProj.proj.empid,
                                "expenseKey"
                              )
                            }
                            className={`z-[998] cursor-pointer py-1 px-2 inline-block border rounded-md text-start ${
                              getCurrentView(
                                projectIndex,
                                clickedProj.proj.empid
                              ) === "expenseKey"
                                ? "bg-blue-500 text-white"
                                : "bg-white"
                            }`}
                          >
                            {"Other Expenses"}
                          </div>
                        </div>

                        {clickedProj?.proj?.TypeService?.toLowerCase().includes(
                          "hardware"
                        )
                          ? getCurrentView(
                              projectIndex,
                              clickedProj.proj.empid
                            ) === "taskKey" && (
                              <>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  className="w-full rounded-lg h-full justify-center pb-5"
                                >
                                  <div className="w-full border border-gray-300  overflow-hidden">
                                    <div className="flex text-center bg-[#e8e8e8] text-[11px]">
                                      <div className="w-[30%] p-1 border-l  text-center">
                                        Parts
                                      </div>
                                      <div className="w-[20%] p-1 text-center">
                                        Quantity
                                      </div>
                                      <div className="w-[20%] p-1 text-center">
                                        Unit Price
                                      </div>
                                      <div className="w-[30%] p-1 border-r text-center">
                                        Price ({currency})
                                      </div>
                                    </div>
                                    <div className="flex text-center text-[11px] border-b">
                                      <div className="w-[30%] p-1 border-l  text-center"></div>
                                      <div className="w-[20%] p-1 text-center"></div>
                                      <div className="w-[20%] p-1 text-center"></div>
                                      <div className="w-[30%] p-1 border-r text-center">
                                        {USAComma(
                                          clickedProj?.entries?.reduce(
                                            (sum, item) =>
                                              sum + item.totalprice,
                                            0
                                          ) || 0
                                        )}
                                      </div>
                                    </div>

                                    {clickedProj?.entries?.map(
                                      (entry, index) => (
                                        <div
                                          key={index}
                                          className="flex text-center text-[11px]"
                                        >
                                          <div className="w-[30%] border-b p-1">
                                            {entry?.assemblepartdescription}
                                          </div>
                                          <div className="w-[20%] border-b p-1">
                                            {entry?.quantity}
                                          </div>
                                          <div className="w-[20%] border-b p-1">
                                            {entry?.unitprice}
                                          </div>
                                          <div className="w-[30%] border-b p-1">
                                            {USAComma(entry?.totalprice)}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </>
                            )
                          : getCurrentView(
                              projectIndex,
                              clickedProj.proj.empid
                            ) === "taskKey" && (
                              <div className="w-full flex gap-2">
                                <div className="w-full max-h-[14rem] overflow-auto">
                                  <div className="flex text-center text-[11px] sticky top-0 z-10 bg-[#e8e8e8]">
                                    <div className="w-[40%] border-l p-1">
                                      Task
                                    </div>
                                    <div className="w-[30%]  p-1">Hrs</div>
                                    <div className="w-[30%] border-r p-1">
                                      Notes
                                    </div>
                                  </div>
                                  <div className="flex text-center text-[11px] font-semibold bg-gray-100">
                                    <div className="w-[40%] border-b border-l p-1">
                                      Total
                                    </div>
                                    <div className="w-[30%] border-b p-1">
                                      {formatHours(
                                        Array.isArray(clickedProj?.entries)
                                          ? clickedProj.entries.reduce(
                                              (sum, item) =>
                                                sum + (item.hoursassigned || 0),
                                              0
                                            )
                                          : 0
                                      )}
                                    </div>
                                    <div className="w-[30%] border-b border-r p-1"></div>
                                  </div>
                                  {clickedProj?.entries?.map((entry, index) => {
                                    const matchedOldWorkEntry = entries.find(
                                      (old) => old._id === entry.oldtaskid
                                    );
                                    return (
                                      <div
                                        key={index}
                                        className="flex text-center text-[11px]"
                                      >
                                        <div
                                          className="w-[40%]  border-b  border-l p-1"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Name: ${matchedOldWorkEntry.task}`
                                              : ""
                                          }
                                        >
                                          {entry.task}
                                        </div>
                                        <div
                                          className="w-[30%]  border-b p-1"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                              : ""
                                          }
                                        >
                                          {entry.hoursassigned}
                                        </div>
                                        <div
                                          className="w-[30%]  border-r  border-b p-1"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                              : ""
                                          }
                                        >
                                          {entry.notes}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}

                        {getCurrentView(
                          projectIndex,
                          clickedProj.proj.empid
                        ) === "expenseKey" &&
                          (clickedProj?.proj?.TypeService?.toLowerCase().includes(
                            "hardware"
                          ) ? (
                            <div className="w-full border  overflow-hidden">
                              <div className="flex text-center bg-[#e8e8e8] text-[11px]">
                                <div className="w-[40%] p-1 border-l text-center">
                                  Description
                                </div>
                                <div className="w-[30%] p-1  text-center">
                                  Amount ({currency})
                                </div>
                                <div className="w-[30%] p-1  border-r text-center">
                                  Notes
                                </div>
                              </div>

                              {clickedProj?.descriptionEntries?.map(
                                (entry, index) => (
                                  <div
                                    key={index}
                                    className="flex text-center text-[11px]"
                                  >
                                    <div className="w-[40%]  border-l  border-b p-1">
                                      {entry?.description}
                                    </div>
                                    <div className="w-[30%]  border-b p-1">
                                      {formatAmountComma(entry?.value)}
                                    </div>
                                    <div className="w-[30%]  border-b  border-r p-1">
                                      {entry?.notes}
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          ) : (
                            <div className="w-full flex gap-2">
                              <div className="w-full max-h-[14rem] overflow-auto">
                                {/* Header */}
                                <div className="flex text-center text-[11px] sticky top-0 z-10">
                                  <div className="w-[40%]  border-l p-1 bg-[#e8e8e8] truncate">
                                    Description
                                  </div>
                                  <div className="w-[30%]  p-1 bg-[#e8e8e8]">
                                    Amount ({currency})
                                  </div>
                                  <div className="w-[30%]  border-r p-1 bg-[#e8e8e8]">
                                    Notes
                                  </div>
                                </div>

                                {/* Total Row */}
                                <div className="flex text-center text-[11px] font-semibold bg-gray-100">
                                  <div className="w-[40%]  border-b  border-l p-1 truncate">
                                    Total
                                  </div>
                                  <div className="w-[30%]  border-b p-1">
                                    {currency}
                                    {formatAmountComma(
                                      clickedProj.descriptionEntries?.reduce(
                                        (sum, item) => {
                                          return sum + parseAmountNumber(item.value);
                                        },
                                        0
                                      )
                                    )}
                                  </div>
                                  <div className="w-[30%]  border-r  border-b p-1"></div>
                                </div>

                                {/* Data Rows */}
                                {clickedProj.descriptionEntries.map(
                                  (description, index) => {
                                    const matchedOldDescription = tasks.find(
                                      (old) => old._id === description.oldtaskid
                                    );
                                    return (
                                      <div
                                        key={index}
                                        className="flex text-center text-[11px]"
                                      >
                                        <div
                                          className="w-[40%]  border-b  border-l p-1"
                                          title={
                                            matchedOldDescription
                                              ? `Previous Name: ${matchedOldDescription.description}`
                                              : ""
                                          }
                                        >
                                          {description.description}
                                        </div>
                                        <div
                                          className="w-[30%]  border-b p-1"
                                          title={
                                            matchedOldDescription
                                              ? `Previous Value: ${matchedOldDescription.value}`
                                              : ""
                                          }
                                        >
                                          {formatAmountComma(description.value)}
                                        </div>
                                        <div
                                          className="w-[30%]  border-b  border-r p-1"
                                          title={
                                            matchedOldDescription
                                              ? `Previous Note: ${matchedOldDescription.notes}`
                                              : ""
                                          }
                                        >
                                          {description.notes}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                )}
              {/* Separator line per service-type block */}
              <div className="w-full border-b-2 border-gray-400" aria-hidden="true" />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AssignShowTasks;
